module.exports = __webpack_public_path__ + "assets/img/s2.3ad6b266.png";